import { SupportedListScreens } from 'app/area/codetable/list/list-renderer/supported-screens';

export const endpoints = {
  details: (codeId: number) => `optionsCollection/${SupportedListScreens.RiskMatrixAdministration}/code/${codeId}`,
  riskAreas: () => `optionsCollection/${SupportedListScreens.RiskArea}/search`,
  axis: (axisCodetableId: number) => `optionsCollection/${axisCodetableId}/search`,
  cells: () => 'riskMatrix/cell/search',
  types: () => 'riskMatrix/type/options',
  update: () => 'riskMatrix/matrix',
  caseTypes: (riskMatrixTypeId: number) => `riskMatrix/type/${riskMatrixTypeId}/caseType`
};
